export const InputLabelProps = {
  style: {
    paddingLeft: '55px',
    color: 'rgb(173, 183, 208)',
    fontSize: '14px'
  }
}